<p>platformsetup works!</p>
